<p>platformsetup works!</p>
